import { gql, type TypedDocumentNode } from '@apollo/client';
import { useEffect } from 'react';

import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import type {
  useEnsureReferrerCodeMutation,
  useEnsureReferrerCodeMutationVariables,
} from './__generated__/useEnsureReferrerCode.graphql';

const GENERATE_REFERRER_CODE_MUTATION = gql`
  mutation useEnsureReferrerCodeMutation($input: generateReferrerCodeInput!) {
    generateReferrerCode(input: $input) {
      currentUser {
        slug
        referrerCode
      }
      errors {
        path
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  useEnsureReferrerCodeMutation,
  useEnsureReferrerCodeMutationVariables
>;

export const useEnsureReferrerCode = (
  referrerCode: string | null | undefined,
  { skip }: { skip?: boolean } = {}
) => {
  const [generateReferrerCode, { loading, called }] = useMutation(
    GENERATE_REFERRER_CODE_MUTATION,
    { showErrorsInForm: true }
  );

  useEffect(() => {
    if (skip || called || referrerCode) return;
    generateReferrerCode({ variables: { input: {} } });
  }, [skip, called, referrerCode, generateReferrerCode]);

  return { generating: loading };
};
